import type { SxProps, Theme } from '@mui/material/styles';

export const rootSx: SxProps<Theme> = {
  px: { xs: 2, sm: 3 },
  pt: { xs: 3, sm: 6 },
  pb: 3,
  maxWidth: 758,
  mx: 'auto',
};

export const headerStackSx: SxProps<Theme> = {
  mb: 3,
};

export const loaderBoxSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  py: 8,
};

export const emptyPaperSx: SxProps<Theme> = {
  p: 4,
  textAlign: 'center',
};

export const listStackSx: SxProps<Theme> = {
  width: '100%',
  alignItems: 'center',
};

export const listItemContentSx: SxProps<Theme> = {
  flexGrow: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: 0.75,
  overflow: 'hidden',
  py: 1,
  pr: 2,
};

export const chipSx: SxProps<Theme> = {
  lineHeight: 1.25,
};
